import { Delete } from '@mui/icons-material';
import { Box, Button, FormHelperText, Typography } from '@mui/material';
import { FC } from 'react';
import { useDropzone } from 'react-dropzone';
import { FileDrop } from './';

interface IFileUploader {
  handleFile: (file: File | null) => void;
  templateFile: string;
  isRequired: boolean;
  dropzoneText?: string;
  removeText?: string;
  handleRemove?: () => void;
}

export const FileUploader: FC<IFileUploader> = ({
  handleFile,
  templateFile,
  isRequired,
  dropzoneText = 'Add File',
  removeText = 'Remove & Replace',
  handleRemove,
}) => {
  const dropzone = useDropzone({
    accept: {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    },
    useFsAccessApi: false,
    onDrop: acceptedFiles => {
      handleFile(acceptedFiles[0]);
    },
  });
  return (
    <>
      {templateFile &&
        (handleRemove ? (
          <div>
            <Box display="flex" marginTop="1rem" alignItems="center">
              <Box flex={1}>
                <Typography>{templateFile}</Typography>
              </Box>
              <Button
                onClick={e => {
                  handleRemove();
                }}
                startIcon={<Delete />}
              >
                {removeText}
              </Button>
            </Box>
          </div>
        ) : (
          <div {...dropzone.getRootProps()}>
            <Box display="flex" marginTop="1rem" alignItems="center">
              <Box flex={1}>
                <Typography>{templateFile}</Typography>
              </Box>
              <Button
                onClick={e => {
                  e.preventDefault();
                }}
                startIcon={<Delete />}
              >
                {removeText}
              </Button>
            </Box>
            <input id="template-file-drop" {...dropzone.getInputProps()} />
          </div>
        ))}
      {!templateFile && (
        <>
          <Box>
            <FileDrop id="template-file-drop" {...dropzone} title={dropzoneText}>
              <Typography variant="body1">
                <a href="/#" onClick={e => e.preventDefault()}>
                  Browse and pick
                </a>{' '}
                a file.
              </Typography>
            </FileDrop>
          </Box>
          {isRequired && <FormHelperText error>Required</FormHelperText>}
        </>
      )}
    </>
  );
};
